<!-- eslint-disable max-len -->
<template>
  <div
    :id="id"
    class="c-modal modal"
    tabindex="0"
    style="
      z-index: 1003;
      display: none;
      opacity: 0;
      top: 4%;
      transform: scaleX(0.8) scaleY(0.8);
    "
  >
    <div
      id="modalTypeCardTwo"
      :class="{
        'c-modal--option-closeDeleteCard': addCard === true,
      }"
    >
      <div class="c-modal--directions-title"><h2>Método de pago</h2></div>
      <div id="" class="c-grid c-section--content-favorite">
        <div class="c-grid--service">
          <div class="c-section--content-article">
            <article class="c-grid--services__item">
              <div class="c-section--content-date">
                <ul class="date-info">
                  <li
                    class="date-info-content cursor-pointer"
                    v-for="card in cards"
                    v-bind:key="card.cardId"
                    @click="selectCard(card)"
                  >
                    <ul class="date-info-content-box">
                      <li class="info-black">
                        <div class="card-icon-content">
                          <img
                            v-if="card.cardBrand.toLowerCase() === 'visa'"
                            src="~@/assets/img/icon/visa.svg"
                            alt="Tarjeta de crédito"
                            width="25"
                            height="25"
                          />
                          <img
                            v-else-if="
                              card.cardBrand.toLowerCase() === 'mastercard'
                            "
                            src="~@/assets/img/icon/mastercard.svg"
                            alt="Tarjeta de crédito"
                            width="25"
                            height="25"
                          />
                          <img
                            v-else-if="card.cardBrand.toLowerCase() === 'amex'"
                            src="~@/assets/img/icon/amex.svg"
                            alt="Tarjeta de crédito"
                            width="25"
                            height="25"
                          />
                          <img
                            v-else-if="
                              card.cardBrand.toLowerCase() === 'diners'
                            "
                            src="~@/assets/img/icon/diners.svg"
                            alt="Tarjeta de crédito"
                            width="25"
                            height="25"
                          />
                          <img
                            v-else-if="
                              card.cardBrand.toLowerCase() === 'unionpay'
                            "
                            src="~@/assets/img/icon/unionpay.svg"
                            alt="Tarjeta de crédito"
                            width="25"
                            height="25"
                          />
                          <img
                            v-else
                            src="~@/assets/img/icon/icon-cardvisa.svg"
                            alt="Tarjeta de crédito"
                            width="25"
                            height="25"
                          />
                          {{ card.cardBrand + " " + card.cardNumber }}
                        </div>
                      </li>
                      <ul
                        class="info-light"
                        v-show="selectedCardId === card.cardId"
                      >
                        <a href="javascript:void(0)" id="btnOpenModalCardvisa"
                          ><img
                            src="~@/assets/img/icon/icon-verificate.svg"
                            width="20px"
                            height="20px"
                        /></a>
                      </ul>
                    </ul>
                  </li>
                </ul>
              </div>
            </article>
          </div>
        </div>
      </div>
      <div id="" class="c-grid c-section--content-favorite">
        <div class="c-grid--service">
          <div class="c-section--content-article">
            <article class="c-grid--services__item">
              <div class="c-section--content-date">
                <ul class="date-info">
                  <li class="date-info-content">
                    <ul
                      class="date-info-content-box justify-content-center font-weight-light"
                    >
                      <li class="info-black">
                        <div class="card-icon-content">
                          <a
                            href="javascript:void(0)"
                            id="addCard-new"
                            @click="addCard = true"
                            class="d-flex align-items-center color-black"
                          >
                            <img
                              src="~@/assets/img/icon/icon-add.svg"
                              alt="Icono de agregar tarjeta"
                              width="34"
                              height="34"
                            />
                            Agregar nueva tarjeta
                          </a>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </article>
            <article class="c-grid--services__item">
              <div class="c-section--content-date">
                <ul class="date-info">
                  <li class="date-info-content">
                    <ul
                      class="date-info-content-box justify-content-center font-weight-light"
                    >
                      <li class="info-black">
                        <div class="card-icon-content">
                          <a
                            href="javascript:void(0)"
                            id="selectPagoEfectivo"
                            @click="sendPagoEfectivo"
                            class="d-flex align-items-center color-black"
                          >
                            <img
                              src="~@/assets/img/icon/pagoefectivo.svg"
                              alt="Icono PagoEfectivo"
                              width="34"
                              height="34"
                            />
                            PagoEfectivo
                          </a>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </article>
          </div>
        </div>
      </div>
      <div class="c-modal__footer-buttons c-nav m-1">
        <button
          class="c-button c-button--primary c-button--width-fuid c-button--mobile-small waves-effect"
          @click="sendCard"
        >
          Seleccionar
        </button>
        <button
          class="c-button c-button--primary c-button--width-fuid c-button--flat c-button--mobile-small waves-effect modal-close"
        >
          Cancelar
        </button>
      </div>
    </div>
    <div
      id="modalTypeAddCard"
      class="c-modal"
      :class="{
        'c-modal--option-closeDeleteCard': addCard === false,
        'c-modal c-modal--option-openDeleteCard': addCard === true,
      }"
    >
      <div class="c-modal--directions-title"><h2>Agregar tarjeta</h2></div>
      <div class="c-box--credit-card">
        <div class="row">
          <div class="col s12">
            <div class="c-input input-field c-input--white">
              <input
                type="text"
                v-model="cardNumber"
                placeholder="#################"
                v-cardformat:formatCardNumber
              />
              <label for="" class="active">Número de tarjeta</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col s7">
            <div class="c-input input-field c-input--white">
              <input
                type="text"
                v-model="cardExpiry"
                placeholder="MM/YYYY"
                v-cardformat:formatCardExpiry
              />
              <label for="" class="active">Fecha</label>
            </div>
          </div>
          <div class="col s5">
            <div class="c-input input-field c-input--white">
              <input
                type="text"
                v-model="cardCvc"
                placeholder="CVV"
                v-cardformat:formatCardCVC
              />
              <label for="" class="active">CVV</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col s6">
            <div class="c-input input-field c-input--white">
              <input type="text" v-model="newCard.name" />
              <label
                for=""
                class="active"
                style="
                  font-size: 14px;
                  background: #3e3d3d;
                  width: auto;
                  padding: 0em 0.5em;
                  color: #fff;
                  transform: translateX(15px) translateY(-9px) scale(0.9);
                  transform-origin: 0 0;
                "
                >Titular</label
              >
            </div>
          </div>
          <!-- <div class="col s6">
            <div class="c-input input-field c-input--white">
              <input type="text" v-model="newCard.alias" />
              <label
                for=""
                class="active"
                style="
                  font-size: 14px;
                  background: #3e3d3d;
                  width: auto;
                  padding: 0em 0.5em;
                  color: #fff;
                  transform: translateX(15px) translateY(-9px) scale(0.9);
                  transform-origin: 0 0;
                "
                >Alias</label
              >
            </div>
          </div> -->
        </div>
      </div>
      <!-- <div class="c-modal--directions-body" style="margin-bottom: 30px">
        <div style="display: none">
          <input
            type="text"
            size="50"
            data-culqi="card[email]"
            id="card[email]"
            v-model="newCard.email"
          />
        </div>
        <div class="c-input input-field">
          <input
            type="text"
            v-model="newCard.alias"
            placeholder="------------------"
          />
          <label for="">Alias o nombre de la tarjeta</label>
        </div>
        <div class="c-input input-field">
          <input
            type="text"
            v-model="newCard.name"
            placeholder="------------------"
          />
          <label for="">Nombre titular o tarjeta habiente</label>
        </div>
        <div class="c-input input-field">
          <input
            type="text"
            v-model="cardNumber"
            placeholder="#################"
            v-cardformat:formatCardNumber
          />
          <label for="">Número de tarjeta</label>
        </div>
        <div class="row m-0">
          <div class="col s6 p-0">
            <div class="c-input input-field mr-1">
              <input
                type="text"
                v-model="cardExpiry"
                placeholder="MM/YYYY"
                v-cardformat:formatCardExpiry
              />
              <label for="">Fecha</label>
            </div>
          </div>
          <div class="col s3 p-0">
            <div class="c-input input-field">
              <input
                type="text"
                v-model="cardCvc"
                placeholder="CVV"
                v-cardformat:formatCardCVC
              />
              <label for="">CVV</label>
            </div>
          </div>
        </div>
      </div> -->
      <div class="c-modal__footer-buttons c-nav m-1">
        <button
          class="c-button c-button--primary c-button--width-fuid c-button--mobile-small waves-effect"
          @click="validateCard()"
        >
          Guardar
        </button>
        <button
          class="c-button c-button--primary c-button--width-fuid c-button--flat c-button--mobile-small waves-effect modal-return-option"
          @click="addCard = false"
        >
          Cancelar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { addCard } from "../../services/cards";
/* eslint-disable no-undef */
export default {
  name: "ModelTypeCard",
  data() {
    return {
      selectedCardId: 0,
      selectedCard: null,
      addCard: false,
      newCard: {
        alias: " ",
        name: null,
        number: null,
        year: null,
        month: null,
        cvv: null,
        email: null,
      },
      sessionToken: null,
      cardCvc: null,
      cardExpiry: null,
      cardNumber: null,
    };
  },
  props: {
    id: String,
  },
  methods: {
    setDefaultNewCard() {
      this.newCard = {
        alias: null,
        name: null,
        number: null,
        year: null,
        month: null,
        cvv: null,
        email: null,
      };
    },
    async fetchCards() {
      this.showLoading();
      await this.$store
        .dispatch("GET_CARDS")
        .then((success) => {
          this.$swal.close();
          if (success.status === 200) {
            const cards = success.data.result;
            this.$store.dispatch("GENERAL_SET_CARDS", cards);
          } else {
            this.showError(success.data.message);
          }
        })
        .catch((error) => {
          const msg = error?.data?.message || "Ocurrio un error.";
          this.showError(msg);
        });
    },
    async secureTokenCreation() {
      if (window.Culqi.token && window.Culqi.token.object === "token") {
        await this.completeAddCard();
      } else {
        this.$swal.close();
        this.showError(
          window.Culqi.error.user_message
            ? window.Culqi.error.user_message
            : window.Culqi.token.user_message
        );
      }
    },
    async timeout(ms) {
      // eslint-disable-next-line no-promise-executor-return
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async saveNewCard() {
      const isValid = this.validateNewCard();
      if (isValid === true) {
        window.Culqi.createToken();
        this.showLoading();
        await this.timeout(3000);
        await this.secureTokenCreation();
      }
    },
    padMonthZero(e) {
      const element = e.target;
      const { value } = element;
      if (value === "") return;
      this.newCard.month = value.padStart(2, "0");
    },
    selectCard(card) {
      this.selectedCardId = card.cardId;
      this.selectedCard = card;
    },
    sendCard() {
      this.$emit("getCardData", this.selectedCard);
      this.closeModal(this.id);
    },
    sendPagoEfectivo() {
      this.$emit("getCardData", {cardId: -1, cardBrand: 'PagoEfectivo', cardNumber: ''});
      this.closeModal(this.id);
    },
    async validateCard() {
      try {
        if (!this.newCard.name) {
          this.showError("Ingrese el nombre del titular");
          return;
        }
        if (!this.cardNumber) {
          this.showError("Ingrese el número de tarjeta");
          return;
        }
        if (!this.cardExpiry) {
          this.showError("Ingrese la fecha de expiración");
          return;
        }
        if (this.cardExpiry.length < 4) {
          this.showError("La fecha de expiración no es valida");
          return;
        }
        const monthCardExpirity = this.cardExpiry?.split("/")[0].trim();
        let yearCardExpirity = this.cardExpiry?.split("/")[1]?.trim();
        if (yearCardExpirity.length === 2) {
          yearCardExpirity = `20${yearCardExpirity}`;
        }
        if (yearCardExpirity.length !== 2 && yearCardExpirity.length !== 4) {
          this.showError("La fecha de expiración no es valida");
          return;
        }
        if (!this.cardCvc) {
          this.showError("Ingrese el CVV de su tarjeta");
          return;
        }
        const data = {
          cardNumber: this.cardNumber.replace(/\s+/g, ""),
          cardHolderName: this.newCard.name,
          cardExpirationDate: `${yearCardExpirity}/${monthCardExpirity}`,
          cardSecurityCode: this.cardCvc,
          alias: this.newCard.alias,
        };
        this.showLoading();
        const res = await addCard(data);
        if (res.status === 200) {
          this.showOk("¡tarjeta agregada con éxito!", this.fetchCards);
          this.addCard = false;
          this.setDefaultNewCard();
        } else {
          this.showError(res.data.message);
        }
      } catch (error) {
        console.log(
          "🚀 ~ file: AddEditCard.vue:247 ~ validateCard ~ error",
          error
        );
        this.showError(
          error.message || "Ocurrio un error interno al agregar la tarjeta"
        );
      }
    },
  },
  mounted() {
    this.$nextTick(async () => {
      await this.fetchCards();
      this.newCard.email = this.user?.email;
    });
  },
  computed: {
    cards() {
      return this.$store.getters.GENERAL_CARDS;
    },
    user() {
      return this.$store.getters.USER;
    },
  },
  watch: {
    addCard(value) {
      if (value) {
        payform.setConfiguration(configuration);

        const elementStyles = {
          base: {
            color: "#FFF",
            fontWeight: 700,
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "16px",
            fontSmoothing: "antialiased",
            placeholder: {
              color: "#999999",
            },
            autofill: {
              color: "#e39f48",
            },
          },

          invalid: {
            color: "#E25950",
            "::placeholder": {
              color: "#000",
            },
          },
        };
        /* Caso de uso: Controles independientes */
        // eslint-disable-next-line no-undef
        this.cardNumber = payform.createElement(
          "card-number",
          {
            style: elementStyles,
            placeholder: "Número de tarjeta",
          },
          "txtNumeroTarjeta"
        );
        // eslint-disable-next-line no-undef
        this.cardExpiry = payform.createElement(
          "card-expiry",
          {
            style: elementStyles,
            placeholder: "MM/YY",
          },
          "txtFechaVencimiento"
        );
        // eslint-disable-next-line no-undef
        this.cardCvc = payform.createElement(
          "card-cvc",
          {
            style: elementStyles,
            placeholder: "CVV",
          },
          "txtCvv"
        );
      } else {
        payform.resetData([this.cardNumber]);
        payform.resetData([this.cardExpiry]);
        payform.resetData([this.cardCvc]);
      }
    },
  },
};
</script>

<style>
.StripeElement {
  height: 40px;
  display: flex;
  align-items: center;
  height: 44px !important;
}

#txtCvv > div > iframe {
  width: 150px;
}
</style>
